/* tslint:disable */
/* eslint-disable */
/**
 * Live CSV Data Import Plugin
 * Plugin to handle CSV imported CSV files
 *
 * The version of the OpenAPI document: 1.23.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileMetadata,
  Message,
} from '../models/index';
import {
    FileMetadataFromJSON,
    FileMetadataToJSON,
    MessageFromJSON,
    MessageToJSON,
} from '../models/index';

export interface DeleteRequest {
    uid?: string;
    eventTypeName?: string;
}

export interface AllowReplayRequest {
    uid?: string;
    allowReplay?: boolean;
    eventTypeName?: string;
}

export interface DetailsRequest {
    uid?: string;
    eventTypeName?: string;
}

export interface DisableRequest {
    uid?: string;
    disabled?: boolean;
    eventTypeName?: string;
}

export interface ListRequest {
    extension?: string;
    eventTypeName?: string;
}

export interface UpdateMetadataRequest {
    uid?: string;
    eventTypeName?: string;
    fileMetadata?: FileMetadata;
}

export interface UploadLogRequest {
    eventTypeName?: string;
    wellName?: string;
    rigName?: string;
    wellboreName?: string;
    logName?: string;
    logType?: string;
    indexColumn?: string;
    indexFormat?: string;
    timezone?: string;
    unitsOnHeader?: boolean;
    nullValues?: string;
    sourceName?: string;
    sourceKind?: string;
    protocolName?: string;
}

/**
 * 
 */
export class CSVApi extends runtime.BaseAPI {

    /**
     * Delete file from the system.
     * Delete file
     */
    async _deleteRaw(requestParameters: DeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Delete file from the system.
     * Delete file
     */
    async _delete(requestParameters: DeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this._deleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change the allow replay status of a given file.
     * Allow replay
     */
    async allowReplayRaw(requestParameters: AllowReplayRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        if (requestParameters['allowReplay'] != null) {
            queryParameters['allowReplay'] = requestParameters['allowReplay'];
        }

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/allowReplay`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Change the allow replay status of a given file.
     * Allow replay
     */
    async allowReplay(requestParameters: AllowReplayRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.allowReplayRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all channels.
     * Get channels
     */
    async channelsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/channels`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all channels.
     * Get channels
     */
    async channels(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.channelsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get details of a file.
     * Get file details
     */
    async detailsRaw(requestParameters: DetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FileMetadata>>> {
        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/details`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FileMetadataFromJSON));
    }

    /**
     * Get details of a file.
     * Get file details
     */
    async details(requestParameters: DetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FileMetadata>> {
        const response = await this.detailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Change the enable/disable status of a given file.
     * Disable / Enable file
     */
    async disableRaw(requestParameters: DisableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        if (requestParameters['disabled'] != null) {
            queryParameters['disabled'] = requestParameters['disabled'];
        }

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/disable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Change the enable/disable status of a given file.
     * Disable / Enable file
     */
    async disable(requestParameters: DisableRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.disableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all files.
     * List files
     */
    async listRaw(requestParameters: ListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FileMetadata>>> {
        const queryParameters: any = {};

        if (requestParameters['extension'] != null) {
            queryParameters['extension'] = requestParameters['extension'];
        }

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FileMetadataFromJSON));
    }

    /**
     * List all files.
     * List files
     */
    async list(requestParameters: ListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FileMetadata>> {
        const response = await this.listRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update metadata of a file.
     * Update metadata
     */
    async updateMetadataRaw(requestParameters: UpdateMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        const queryParameters: any = {};

        if (requestParameters['uid'] != null) {
            queryParameters['uid'] = requestParameters['uid'];
        }

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/csv/updateMetadata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FileMetadataToJSON(requestParameters['fileMetadata']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Update metadata of a file.
     * Update metadata
     */
    async updateMetadata(requestParameters: UpdateMetadataRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.updateMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload a log file.
     * Upload log file
     */
    async uploadLogRaw(requestParameters: UploadLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        const queryParameters: any = {};

        if (requestParameters['eventTypeName'] != null) {
            queryParameters['eventTypeName'] = requestParameters['eventTypeName'];
        }

        if (requestParameters['wellName'] != null) {
            queryParameters['wellName'] = requestParameters['wellName'];
        }

        if (requestParameters['rigName'] != null) {
            queryParameters['rigName'] = requestParameters['rigName'];
        }

        if (requestParameters['wellboreName'] != null) {
            queryParameters['wellboreName'] = requestParameters['wellboreName'];
        }

        if (requestParameters['logName'] != null) {
            queryParameters['logName'] = requestParameters['logName'];
        }

        if (requestParameters['logType'] != null) {
            queryParameters['logType'] = requestParameters['logType'];
        }

        if (requestParameters['indexColumn'] != null) {
            queryParameters['indexColumn'] = requestParameters['indexColumn'];
        }

        if (requestParameters['indexFormat'] != null) {
            queryParameters['indexFormat'] = requestParameters['indexFormat'];
        }

        if (requestParameters['timezone'] != null) {
            queryParameters['timezone'] = requestParameters['timezone'];
        }

        if (requestParameters['unitsOnHeader'] != null) {
            queryParameters['unitsOnHeader'] = requestParameters['unitsOnHeader'];
        }

        if (requestParameters['nullValues'] != null) {
            queryParameters['nullValues'] = requestParameters['nullValues'];
        }

        if (requestParameters['sourceName'] != null) {
            queryParameters['sourceName'] = requestParameters['sourceName'];
        }

        if (requestParameters['sourceKind'] != null) {
            queryParameters['sourceKind'] = requestParameters['sourceKind'];
        }

        if (requestParameters['protocolName'] != null) {
            queryParameters['protocolName'] = requestParameters['protocolName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/csv/uploadLog`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Upload a log file.
     * Upload log file
     */
    async uploadLog(requestParameters: UploadLogRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.uploadLogRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
